import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { ENTITY_ACCESS_TYPE, RESOURCE_TYPE, RESOURCES } from '../../../HelperMethods/role-resource-constants';
import ShouldComponentRender from '../ShouldComponentRender';
import taskCardStyles from './TaskCard.module.css';
import taskBoxstyles from '../taskBox/TaskBox.module.css';

import { toggleWatcher, onConfirmTask } from '../../taskView/TaskViewPage/redux/actions';
import { loadManifestForm, clearManifestForm } from '../../taskView/TaskViewPage/ManageTaskForm/redux/actions';

import { closeView } from '../cardNavigationComponent/cardNavigationRedux';
import cardStyles from '../Card.module.css';
import { ReactComponent as EditIcon } from '../../../icons/edit.svg';
import { ReactComponent as WatcherIcon } from '../../../icons/watcher.svg';
import { ReactComponent as SelectedWatcherIcon } from '../../../icons/watcher-selected.svg';
import { getTaskByIdSelector } from '../../taskView/TaskViewPage/redux/reducer';
import TaskAssignee from '../TaskAssignee';
import { convertUTCDateStringToYYYYMMDDHHMMSSFormat } from '../../../HelperMethods/DateUtils';
import { setTaskDistanceAndDurationKpis, TASK_CARD_ERROR_VALUE, TASK_CARD_VALUE_LOADING } from './redux/actions';
import { parseJSONStringToObject } from '../../../HelperMethods/UtilityFunctions';
import { findTimeForReminder } from '../../../HelperMethods/TaskUtilities';
import { EditMode, TaskStatus, lockIcon } from '../../../HelperMethods/constants';
import { STATUS_LIST_VALUE_KEYED } from '../../../HelperMethods/enums';
import FormPreview from '../form-preview/FormPreviewComponent';
import CopyComponent from '../CopyComponent';

const TaskCard = React.memo(function TaskCard({ taskId, container, tasksEditMode }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [showPdfIcon, togglePdfIcon] = useState(false);
  const {
    tasks: { items: allTasks },
    users: { items: allUsers },
  } = useSelector((state) => state.taskViewPageReducer);
  const { loggedInUser } = useSelector((state) => state.appReducer);
  const { manifestForm } = useSelector((state) => state.manageTaskFormReducer);
  let { schema: manifestFormSchema, data: formData } = manifestForm;
  const allPicklists = useSelector((state) => state.formReducer.pickLists);
  const picklistMappings = useSelector((state) => state.picklistMappingReducer.picklistMappings);

  const task = useSelector(getTaskByIdSelector(taskId));

  useEffect(() => {
    return () => {
      dispatch(clearManifestForm());
    };
  }, []);

  useEffect(() => {
    if (!task) {
      setConfirmClicked(true);
      dispatch(closeView(container));
    } else {
      dispatch(clearManifestForm());
      togglePdfIcon(false);
      dispatch(loadManifestForm(task?.taskType, task));
    }
  }, [task]);

  useEffect(() => {
    if (manifestForm && !manifestForm.isLoading && !showPdfIcon) {
      const { schema, data } = manifestForm;
      if (manifestFormSchema?.data?.elements?.length) {
        manifestFormSchema = schema;
        formData = data;
        // formPicklist = picklistVar;
        togglePdfIcon(true);
      }
    }
  }, [manifestForm]);
  useEffect(() => {
    if (task) {
      dispatch(setTaskDistanceAndDurationKpis(task, allTasks, allUsers));
    }
  }, [taskId]);
  const addWatcher = useCallback(() => {
    dispatch(toggleWatcher(task, loggedInUser.id));
  }, [task, loggedInUser, dispatch]);

  const onConfirm = useCallback(() => {
    dispatch(onConfirmTask(task));
  }, [task, loggedInUser, dispatch]);

  const { distanceFromSite, durationFromSite } = useSelector((state) => state.taskCardReducer);
  const data = parseJSONStringToObject(task?.data);
  if (!task) return null;
  const reminder = findTimeForReminder(task);
  const showConfirmButton = !confirmClicked && task.status === TaskStatus.DRAFT && tasksEditMode === EditMode.PUBLISHED;
  return (
    <div className={cardStyles.card}>
      <div className={cardStyles.cardHeader}>
        <div className={cardStyles.taskHeaderLines} style={{ paddingLeft: '24px' }}>
          <div className={cardStyles.mainHeader} style={{ position: 'relative' }}>
            {task?.taskType?.name} &nbsp;{' '}
            {task.isTaskLocked ? (
              <div>
                <div style={{ marginTop: '3px' }}>
                  <img
                    src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(lockIcon)}`}
                    className="tooltip-icon"
                    width="16px"
                  />
                </div>
              </div>
            ) : null}
          </div>
          <div className={cardStyles.subHeader}>{task?.asset?.stop?.name}</div>
        </div>
      </div>
      <div className={cardStyles.cardContent}>
        <div
          className={cardStyles.row}
          style={{
            background: 'rgba(200, 244, 240, 0.17)',
            padding: '0 16px',
            justifyContent: 'space-between',
            position: 'relative',
          }}
        >
          <div className={cardStyles.rowTitle}>Actions</div>
          <div style={{ display: 'flex' }}>
            <ShouldComponentRender
              resource={RESOURCES.ENTITY.TASK}
              resourceType={RESOURCE_TYPE.ENTITY}
              entityAccessType={ENTITY_ACCESS_TYPE.UPDATE}
              entity={task}
            >
              <div
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '25px' }}
                onClick={() => {
                  history.push(`/taskViewPage/task/update/${task?.id}`);
                }}
              >
                <EditIcon />
                &nbsp;&nbsp;&nbsp;Edit
              </div>
            </ShouldComponentRender>

            <WatcherButton onButtonClicked={addWatcher} selected={!!task?.watcherIds?.includes(loggedInUser.id)} />
            {showConfirmButton && (
              <ShouldComponentRender
                resource={RESOURCES.ENTITY.TASK}
                resourceType={RESOURCE_TYPE.ENTITY}
                entityAccessType={ENTITY_ACCESS_TYPE.UPDATE}
                entity={task}
              >
                <Button
                  type="button"
                  className="black"
                  style={{
                    display: 'inline-block',
                    padding: '7px 10px',
                    position: 'absolute',
                    right: '8px',
                    top: '8px',
                    fontSize: '12px',
                  }}
                  onClick={() => onConfirm()}
                >
                  Confirm
                </Button>
              </ShouldComponentRender>
            )}
          </div>
        </div>
        {showPdfIcon && manifestFormSchema?.data?.elements?.length && (
          <div className={taskCardStyles.row}>
            <div className={taskCardStyles.rowLabel}>Print</div>
            <div>
              <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                <FormPreview
                  task={task}
                  formData={formData}
                  originalSchema={manifestFormSchema}
                  loggedInUser={loggedInUser}
                  // picklistDict={_.keyBy(formPicklist, 'id')}
                  onlyForPrint
                  readOnly
                  allPicklistData={allPicklists}
                  picklistMappings={picklistMappings}
                  buttonStyle={{ background: 'none', padding: '4px 5px' }}
                  printLabel="Print"
                />
              </div>
            </div>
          </div>
        )}
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Task #</div>
          <div className={taskCardStyles.rowValue}>
            {task?.taskNumber}&nbsp;&nbsp;
            <CopyComponent textToCopy={task?.taskNumber} floatPosition="none" />
          </div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Status</div>

          <div className={taskCardStyles.rowValue}>
            <span
              className={taskBoxstyles.taskPropertySymbol}
              style={{ background: STATUS_LIST_VALUE_KEYED[task.status].color }}
            />
            <span>{STATUS_LIST_VALUE_KEYED[task.status].text}</span>
          </div>
        </div>
        {reminder && (
          <div className={taskCardStyles.row}>
            <div className={taskCardStyles.rowLabel}>Reminder</div>
            <div className={taskCardStyles.rowValue}>
              <span className="reminder-indicator" />
              {reminder}
            </div>
          </div>
        )}
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Assigned To</div>
          <div className={taskCardStyles.rowValue}>
            <TaskAssignee task={task} container={container} />
          </div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Source</div>
          <div className={taskCardStyles.rowValue}>{task?.eventSource}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Stop</div>
          <div className={taskCardStyles.rowValue}>{task?.asset?.stop?.name}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Asset</div>
          <div className={taskCardStyles.rowValue}>{task?.asset?.name}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>WO#</div>
          {/* eslint-disable-next-line camelcase */}
          <div className={taskCardStyles.rowValue}>{data?.s_workordernumber}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Start Time</div>
          <div className={taskCardStyles.rowValue}>{convertUTCDateStringToYYYYMMDDHHMMSSFormat(task?.startTime)}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>End Time</div>
          <div className={taskCardStyles.rowValue}>{convertUTCDateStringToYYYYMMDDHHMMSSFormat(task?.endTime)}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Default Duration</div>
          <div className={taskCardStyles.rowValue}>{`${task?.duration} mins`}</div>
        </div>
        <div className={taskCardStyles.row}>
          <div className={taskCardStyles.rowLabel}>Delayed By</div>
          <div className={taskCardStyles.rowValue}>{`${task?.delayedBy || 0} mins`}</div>
        </div>
        {!_.isNil(distanceFromSite) && (
          <div className={taskCardStyles.row}>
            <div className={taskCardStyles.rowLabel}>Distance From Site</div>
            <div className={taskCardStyles.rowValue}>
              {/* eslint-disable-next-line no-nested-ternary */}
              {distanceFromSite === TASK_CARD_VALUE_LOADING
                ? 'Loading'
                : distanceFromSite === TASK_CARD_ERROR_VALUE
                ? 'Api Error'
                : distanceFromSite}
            </div>
          </div>
        )}
        {!_.isNil(durationFromSite) && (
          <div className={taskCardStyles.row}>
            <div className={taskCardStyles.rowLabel}>Distance From Site</div>
            <div className={taskCardStyles.rowValue}>
              {/* eslint-disable-next-line no-nested-ternary */}
              {durationFromSite === TASK_CARD_VALUE_LOADING
                ? 'Loading'
                : durationFromSite === TASK_CARD_ERROR_VALUE
                ? 'Api Error'
                : durationFromSite}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

function WatcherButton({ onButtonClicked, selected }) {
  return (
    <div
      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '10px' }}
      onClick={onButtonClicked}
      data-testid="watcher-button"
    >
      <div
        style={{
          display: 'inline-block',
          background: selected ? '#4d6278' : 'transparent',
          height: '16px',
          width: '16px',
        }}
      >
        {selected ? <SelectedWatcherIcon height="16" width="16" /> : <WatcherIcon height="16" width="16" />}
      </div>
      &nbsp; Watch
    </div>
  );
}

WatcherButton.propTypes = {
  onButtonClicked: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default TaskCard;
